(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product"]) return;
  try {
    
  if (!window.planetNusaColorNavigation) {
    window.planetNusaColorNavigation = true;
    let colorRequest;

    const getSwatchKey = (link) => new URL(link.href, window.location.origin).pathname;

    const reorderSwatches = (component, order, visibleLimit, keepExpanded) => {
      const container = component.querySelector('[data-variant-buttons]');
      if (!container) return;

      const toggle = container.querySelector('show-color-swatches');
      const links = Array.from(container.querySelectorAll('[data-product-color-link]'));
      const positions = new Map(order.map((key, index) => [key, index]));
      links.sort((first, second) => {
        const firstPosition = positions.get(getSwatchKey(first)) ?? Number.MAX_SAFE_INTEGER;
        const secondPosition = positions.get(getSwatchKey(second)) ?? Number.MAX_SAFE_INTEGER;
        return firstPosition - secondPosition;
      });
      links.forEach((link, index) => {
        const isExtra = index >= visibleLimit;
        link.classList.toggle('is-extra', isExtra);
        if (isExtra && !keepExpanded && link.getAttribute('aria-current') !== 'page') {
          link.setAttribute('hidden', '');
        } else {
          link.removeAttribute('hidden');
        }
        container.insertBefore(link, toggle);
      });
    };

    const expandSwatchGroup = (component) => {
      const container = component.querySelector('[data-variant-buttons]');
      if (!container) return;

      container.querySelectorAll('[data-product-color-link].is-extra').forEach((swatch) => {
        swatch.removeAttribute('hidden');
      });
      container.classList.add('is-expanded');

      const toggle = container.querySelector('.color-swatch__show-more');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
    };

    const preserveShippingInfo = (currentComponent, nextComponent) => {
      const currentShippingInfo = currentComponent.querySelector('shipping-info');
      const nextShippingInfo = nextComponent.querySelector('shipping-info');
      if (!currentShippingInfo || !nextShippingInfo) return;

      nextShippingInfo.innerHTML = currentShippingInfo.innerHTML;
    };

    const navigateToColor = async (link) => {
      const currentComponent = link.closest('product-component');
      if (!currentComponent || link.getAttribute('aria-current') === 'page') return;

      const sectionId = currentComponent.dataset.sectionId;
      const targetUrl = new URL(link.href, window.location.origin);
      const requestUrl = new URL(targetUrl.href);
      requestUrl.searchParams.set('section_id', sectionId);
      const currentSwatchContainer = link.closest('[data-variant-buttons]');
      const keepExpanded = currentSwatchContainer?.classList.contains('is-expanded') || false;
      const currentSwatches = Array.from(currentComponent.querySelectorAll('[data-product-color-link]'));
      const swatchOrder = currentSwatches.map(getSwatchKey);
      const firstExtraIndex = currentSwatches.findIndex((swatch) => swatch.classList.contains('is-extra'));
      const visibleLimit = firstExtraIndex === -1 ? currentSwatches.length : firstExtraIndex;

      colorRequest?.abort();
      colorRequest = new AbortController();
      currentComponent.setAttribute('aria-busy', 'true');
      link.classList.add('is-loading');

      try {
        const response = await fetch(requestUrl, {
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          signal: colorRequest.signal
        });
        if (!response.ok) throw new Error(`Product request failed: ${response.status}`);

        const responseText = await response.text();
        const responseDocument = new DOMParser().parseFromString(responseText, 'text/html');
        const nextComponent = responseDocument.querySelector('product-component');
        if (!nextComponent) throw new Error('Product section was missing from the response');
        preserveShippingInfo(currentComponent, nextComponent);
        reorderSwatches(nextComponent, swatchOrder, visibleLimit, keepExpanded);

        const update = () => currentComponent.replaceWith(nextComponent);
        if (document.startViewTransition) {
          await document.startViewTransition(update).finished;
        } else {
          update();
        }

        window.history.pushState({ productColorUrl: targetUrl.href }, '', targetUrl.href);
        if (keepExpanded) expandSwatchGroup(nextComponent);
        document.dispatchEvent(new CustomEvent('theme:product:color-change', {
          detail: { url: targetUrl.href, sectionId }
        }));
      } catch (error) {
        if (error.name !== 'AbortError') window.location.assign(targetUrl.href);
      } finally {
        const activeComponent = document.querySelector(`#Product--${CSS.escape(sectionId)}`);
        activeComponent?.removeAttribute('aria-busy');
      }
    };

    document.addEventListener('click', (event) => {
      const link = event.target.closest('[data-product-color-link]');
      if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      navigateToColor(link);
    });

    window.addEventListener('popstate', () => {
      window.location.reload();
    });
  }

  } catch(e) { console.error(e); }
})();
})();
